import React, { useEffect, useState } from "react";
import "./media.css";
import HeroSectionV2 from "../../../components/HeroSectionV2";
import Billede1 from "../../../Images/Billede1.jpg";

interface Event {
    eventID: number;
    eventName: string;
}

interface FunctionDto {
    functionId: number;
    functionName: string;
}
interface MediaApplication {
    id: number;
    userId: number;
    firstname: string;
    lastname: string;
    email: string;
    functionId: number;
    status: "Pending" | "Approved" | "Denied";
    note: string;
}

const MediaAdminPage: React.FC = () => {
    const apiUrl = process.env.REACT_APP_API_URL as string;

    const [events, setEvents] = useState<Event[]>([]);
    const [selectedEvent, setSelectedEvent] = useState<number | null>(null);
    const [applications, setApplications] = useState<MediaApplication[]>([]);
    const [functions, setFunctions] = useState<FunctionDto[]>([]);

    useEffect(() => {
        fetch(`${apiUrl}/api/events`)
            .then(res => res.json())
            .then(setEvents);
    }, []);

    useEffect(() => {
        if (!selectedEvent) return;
        const loadData = async () => {
            const appRes = await fetch(`${apiUrl}/api/media-applications/event/${selectedEvent}`);
            const appsData = appRes.ok ? await appRes.json() : [];
            setApplications(appsData);

            const funcRes = await fetch(`${apiUrl}/api/events/${selectedEvent}/media-data`);
            const funcData = funcRes.ok ? await funcRes.json() : { functions: [] };
            setFunctions(funcData.functions || []);
        };
        loadData();
    }, [selectedEvent]);

    const handleUpdate = async (appId: number, status: "Approved" | "Denied", note: string) => {
        await fetch(`${apiUrl}/api/media-applications/${appId}/status?status=${status}`, {
            method: "PUT"
        });
        // Refresh
        if (selectedEvent) {
            const res = await fetch(`${apiUrl}/api/media-applications?eventId=${selectedEvent}`);
            const updatedApps = res.ok ? await res.json() : [];
            setApplications(updatedApps);
        }
    };

    return (
        <div>
            <HeroSectionV2
                titleEn="Media"
                titleDa="Media"
                descriptionEn="Application for media access"
                descriptionDa="Ans�gning til medieadgang"
                imageSrc={Billede1}
            />
        <div className="media-admin-container">
            <h1>Admin Media Applications</h1>

            <div style={{ marginBottom: 20 }}>
                <label><strong>Select Event:</strong> </label>
                <select
                    value={selectedEvent ?? ""}
                    onChange={(e) => setSelectedEvent(Number(e.target.value))}
                >
                    <option value="">-- Select Event --</option>
                    {events.map(ev => (
                        <option key={ev.eventID} value={ev.eventID}>{ev.eventName}</option>
                    ))}
                </select>
            </div>

            {selectedEvent && applications.length === 0 && <p>No applications yet for this event.</p>}

            {applications.length > 0 && (
                <table className="media-admin-table">
                    <thead>
                        <tr>
                            <th>User</th>
                            <th>Email</th>
                            <th>Function</th>
                            <th>Status</th>
                            <th>Note</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {applications.map(app => (
                            <tr key={app.id}>
                                <td>{app.firstname} {app.lastname}</td>
                                <td>{app.email}</td>
                                <td>{functions.find(f => f.functionId === app.functionId)?.functionName || "Unknown"}</td>
                                <td>
                                    <span className={`status-badge status-${app.status}`}>
                                        {app.status}
                                    </span>
                                </td>
                                <td>
                                    <textarea
                                        className="note-textarea"
                                        value={app.note}
                                        rows={3}
                                        onChange={(e) => {
                                            const newNote = e.target.value;
                                            setApplications(prev =>
                                                prev.map(a => a.id === app.id ? { ...a, note: newNote } : a)
                                            );
                                        }}
                                    />
                                </td>
                                <td>
                                    <button className="approve-btn" onClick={() => handleUpdate(app.id, "Approved", app.note)}>Approve</button>
                                    <button className="deny-btn" onClick={() => handleUpdate(app.id, "Denied", app.note)}>Deny</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            </div>
        </div>
    );
};

export default MediaAdminPage;